import { DAYS_OF_WEEK, DayOfWeek, Schedule } from '@app/features/horaires/schedules.model';
import { Slot } from '@app/shared/forms/slot-form/slot.model';

const time = (value: string | null) => (value ?? '').slice(0, 5);

/** Les créneaux d'un jour, « 06:00 – 09:00, 17:00 – 20:00 », ou un tiret s'il n'en a pas. */
export function slotsLabel(slots: Slot[] | undefined): string {
  const filled = (slots ?? []).filter((slot) => slot.startTime && slot.endTime);
  return filled.length === 0
    ? '—'
    : filled.map((slot) => `${time(slot.startTime)} – ${time(slot.endTime)}`).join(', ');
}

/** Les créneaux de chaque jour de la semaine, dans l'ordre des jours. */
export function slotsByDay(schedules: Schedule[] | undefined): Record<DayOfWeek, string> {
  return Object.fromEntries(
    DAYS_OF_WEEK.map((day) => [
      day,
      slotsLabel(schedules?.find((schedule) => schedule.day === day)?.slots),
    ]),
  ) as Record<DayOfWeek, string>;
}

/** Deux semaines aux mêmes créneaux, jour par jour. */
export function sameSlots(a: Schedule[] | undefined, b: Schedule[] | undefined): boolean {
  const left = slotsByDay(a);
  const right = slotsByDay(b);
  return DAYS_OF_WEEK.every((day) => left[day] === right[day]);
}
